import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Util, ConnectedFormSelect } from '@grandvisionhq/forms';

var SelectReason = (_param)=>{
    var { className , options  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "options"
    ]);
    const formattedOptions = Util.createSelectOptions(options, 'label');
    return /*#__PURE__*/ React.createElement(ConnectedFormSelect, swcHelpers.extends({
        initialState: undefined,
        required: true,
        className: classnames('return-item__select', className),
        options: formattedOptions
    }, rest));
};

export { SelectReason };
//# sourceMappingURL=SelectReason.js.map
